export const toRem = (pxValue, remPxValue = 16) => `${pxValue / remPxValue}rem`

export const kebabToCamelCase = (str = '') => str.replace(/-+([^-])/g, ($m, $1) => $1.toUpperCase())
